import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import {
  UserExperienceProps,
  UserExperienceParams,
  UserExperienceModelProps,
  UserExperienceItemProps,
} from '../types/userExperience.types';

export const UserExperienceModel = (props: UserExperienceProps): UserExperienceModelProps => {
  const items = props?.fields?.apiData?.items;
  const fields: UserExperienceItemProps | undefined = items?.length ? items[0] : undefined;
  const params: UserExperienceParams | undefined = props?.params;

  return {
    description: { value: appendRootToRichTextInternalLinks(fields?.description) },
    eyebrow: { value: fields?.eyebrow },
    title: { value: fields?.title },
    button1: fields?.button1 && {
      ...fields?.button1,
      href: appendRootToInternalLink(`${fields?.button1?.url}`),
      text: `${fields?.button1?.label}`,
    },
    button2: fields?.button2 && {
      ...fields?.button2,
      href: appendRootToInternalLink(`${fields?.button2?.url}`),
      text: `${fields?.button2?.url}`,
    },
    imagePosition: params?.imagePosition,
    videoUrl: fields?.assets?.[0]?.role === 'extvideo' ? fields?.videoUrl || '' : fields?.assets?.[0]?.full || '',
    videoDescription: fields?.videoDescription || '',
    altText: fields?.assets?.[0]?.alt,
    thumbnail: fields?.assets?.[0]?.thumbnail,
    bigthumbnail: fields?.assets?.[0]?.bigthumbnail,
    isVideo: fields?.assets?.[0]?.role === 'video' || fields?.assets?.[0]?.role === 'extvideo',
  };
};
